import { SET_PARTICIPANTS, ADD_PARTICIPANT, PARTICIPANT_FETCHED } from '../actions';

export default function participants(state = [], action = {}) {
  switch(action.type) {
    case SET_PARTICIPANTS:
      return action.participants;
    case ADD_PARTICIPANT:
      return [
        ...state,
        action.participant
      ];
    case PARTICIPANT_FETCHED:
      const index = state.findIndex(item => item.Id === action.participant.Id);
      if (index > -1) {
        return state.map(item => {
          if (item.Id === action.participant.Id) return action.participant;
          return item;
        });
      } else {
        return [
          ...state,
          action.participant
        ];
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/participants.js